<template>
  <div v-if="data?.label || data?.description" class="section-header-form-item">
    <div class = "content-wrapper">
        <div class="label">{{ data.label }}</div>
        <div v-if="data?.description" class="description">{{ data.description }}</div>
        <div class="divider"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props:{
    data:{
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.section-header-form-item {
    padding: 12px 16px;
}

.content-wrapper {
    padding: 0 6px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.label {
    color: #333;

    /* EHR_TitleL_22_Web */
    font-family: 'Inter', sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 109.091% */
}

.divider {
    margin-top: 4px;
    height: 1px;
    background-color: #C4C4C4;
}
</style>